__turbopack_context__.v({
  "className": "heading_ef9fb34f-module__WiGaBa__className",
  "variable": "heading_ef9fb34f-module__WiGaBa__variable",
});
